export default {
  step1: '注册商户帐号',
  step2: '填写资质信息',
  step3: '填写结算信息',
  step4: '创建店铺',
  step5: '开店审核'
}
